<template lang="html">
  <status-page
    illustration="/img/not-found-page.svg"
    illustration-alt="Illustration of a missing page with a question mark"
    code="404 · Not found"
    title="Page not found"
    message="This page doesn't exist or was removed." />
</template>

<script>
  import StatusPage from '@/components/common/StatusPage.vue';

  /** The page for an address that has no page, or a page that was removed (AVA-697 D10). */
  export default {
    name: 'NotFound',
    components: { StatusPage },
  };
</script>
